import './buttonsblock.less'

import React from 'react'
import {LinkType} from 'types'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Theme} from 'views/theme'

const styles = style('buttonsblock')

export type ButtonsblockType = {
	buttons: Array<LinkType>
}

export const Buttonsblock: React.FC<ButtonsblockType> = ({buttons}) => {
	if (!buttons || buttons.length === 0) return null

	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('buttons')}>
					{buttons.map((button, i) => (
						<div className={styles('buttons-item')}>
							<Theme.Button
								to={button.url}
								className={styles('buttons-item-btn').mod('arrowlong')}
							>
								<Theme.ButtonText>
									{button.description || button.title}
								</Theme.ButtonText>
								<Theme.ButtonIcon icon="arrow-long" />
							</Theme.Button>
						</div>
					))}
				</div>
			</Theme.Container>
		</div>
	)
}
